import * as d3 from 'd3'

export default {

  methods: {

    call_Skyline(selection, d, x, y, width, self=this) {

      selection
      .on('mouseover', function() {
        if(d3.select(this).attr('opacity') < 1 && d.opacity != undefined) return 
        let hovorScale = 1.4
        let factor = (hovorScale - 1) / 2
        let scale_x = width * factor
        let scale_y = self.skyline.height * factor

        self.canvasFront.selectAll('*').remove()

        let hoverBox = self.canvasFront
        .append('g')
        .attr('transform', `translate(${x},${y}) scale(${1})`)
        .style('cursor', 'pointer')
        .on('mouseout', () => {
          self.canvasFront.selectAll('*').remove()
          d3.select(this).transition().duration(150).attr('transform', `translate(${x},${y}) scale(1)`)
          d3.select('#DETAIL_CANVAS').transition().delay(1000).duration(300)
          .attr('opacity', self.detail.onOff == 'ON' ? 1 : 0)
        })
        .on('click', () => {
          self.link_Action('', d,'') 
        })        

        d3.select(this)
        .selectAll('*')
        .each(function () {
          hoverBox.node().appendChild(this.cloneNode(true))
        })        

        hoverBox.transition().duration(150).attr('transform', `translate(${x-scale_x},${y-scale_y}) scale(${hovorScale})`)
        d3.select('#DETAIL_CANVAS').transition().duration(200).attr('opacity', 1)

        self.reflashSVG(d.SYS)

        self.detail_Reflash(d)
      })
    },

    call_Summary(selection, col, data, item, st) {

      if (col.filter == '') return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(50).style('opacity', 1)
        })
        .on('click', () => {
          this.link_Action(col, data, item, st) 
        })
    },


    link_Action(col_, data, item_, st) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data[this.keys[d]]}
      })

      let filterString_ = this.filters[col_.filter] || ''

      if (st == 'HULL') {
        filterString_ += filterString_ ? ` AND [J_AREA] = 'HULL'` : `[J_AREA] = 'HULL'`
      } else if (st == 'TOPSIDE') {
        filterString_ += filterString_ ? ` AND [J_AREA] = 'TOPSIDE'` : `[J_AREA] = 'TOPSIDE'`
      } else if (st == 'LQ') {
        filterString_ += filterString_ ? ` AND [J_AREA] = 'LQ'` : `[J_AREA] = 'LQ'`
      } else {
        filterString_ = this.filters[col_.filter] || ''
      }

      let requestText = (item_.json && item_.json != '') ? item_.json : 'request'
      console.log(requestText, dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(requestText, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },

  } 
}